import { useMemo } from 'react';

import { Breadcrumb } from 'pages/Bulletin/types/breadcrumb';
import { ROUTES } from 'pages/Search/constants';
import { normalizeName } from 'pages/Search/utils';

interface Options {
    id: string;
    type: string;
    title: string;
}

export default function useBreadcrumbs({ id, type, title }: Options) {
    return useMemo(() => {
        const output: Breadcrumb[] = [];

        output.push({ label: 'Vulners', link: ROUTES.ROOT() });
        output.push({
            label: normalizeName(type),
            link: ROUTES.TYPES_CVE({ type, page: null, order: null })
        });
        output.push({ label: title, link: `/${type}/${id}`, disabled: true });

        return output;
    }, [id, title, type]);
}
